import { array, object, string, enum as zEnum } from "zod";

export const getIDFShippingIntegration = {
  name: "getIDFShippingIntegration" as const,
  input: object({}),
  output: object({
    idfShippingIntegration: object({
      clientId: string(),
      tenantId: string(),
      mode: zEnum(["test", "production"]),
      carrierBlacklist: array(string()).optional(),
    }).optional(),
  }),
};
